import styled from "styled-components";

const c = {
  white: "#ffffff",
  black: "#131313",
  blackSoft: "#5f5a57",
  border: "rgba(19,19,19,0.10)",
  borderStrong: "rgba(201,162,39,0.36)",
  gold: "#c9a227",
  goldSoft: "#f8f1db",
  pinkSoft: "#fbf1f6",
  overlay: "rgba(0,0,0,0.72)",
};

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: ${c.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;

  @media (max-width: 768px) {
    padding: 10px;
    align-items: center;
  }
`;

export const ModalCard = styled.div`
  position: relative;
  width: 95%;
  max-width: 980px;
  max-height: 92vh;
  overflow-y: auto;
  background: ${c.white};
  border: 1px solid ${c.borderStrong};
  border-radius: 24px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.22);
  padding: 22px;

  @media (max-width: 768px) {
    max-height: 92vh;
    padding: 14px;
    border-radius: 18px;
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 38px;
  height: 38px;
  border: 1px solid ${c.border};
  border-radius: 999px;
  background: ${c.white};
  color: ${c.black};
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  transition: 0.2s ease;
  z-index: 3;

  &:hover {
    border-color: ${c.gold};
    color: ${c.gold};
    transform: scale(1.03);
  }

  @media (max-width: 768px) {
    width: 34px;
    height: 34px;
    font-size: 22px;
    top: 8px;
    right: 8px;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  gap: 22px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export const GalleryCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MainImage = styled.img`
  width: 100%;
  height: 380px;
  object-fit: cover;
  border-radius: 18px;
  border: 1px solid ${c.borderStrong};
  background: #fafafa;

  @media (max-width: 768px) {
    height: 185px;
    border-radius: 14px;
  }
`;

export const ThumbsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(62px, 1fr));
  gap: 8px;
`;

export const Thumb = styled.img`
  width: 100%;
  height: 62px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
  border: ${({ $active }) =>
    $active ? `2px solid ${c.gold}` : `1px solid ${c.border}`};
  box-shadow: ${({ $active }) =>
    $active ? `0 0 0 2px ${c.goldSoft}` : "none"};
  transition: 0.2s ease;

  &:hover {
    border-color: ${c.gold};
  }

  @media (max-width: 768px) {
    height: 54px;
    border-radius: 8px;
  }
`;

export const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ProductTitle = styled.h2`
  margin: 0 0 10px;
  color: ${c.black};
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(24px, 2.2vw, 34px);
  line-height: 1.08;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding-right: 42px;

  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 1.12;
    margin-bottom: 8px;
    padding-right: 34px;
  }
`;

export const ShortDescription = styled.p`
  margin: 0;
  color: ${c.blackSoft};
  font-size: 14px;
  line-height: 1.7;
  white-space: pre-wrap;

  @media (max-width: 768px) {
    font-size: 13.5px;
    line-height: 1.62;
  }
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const StockBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  border: 1px solid
    ${({ $inStock }) =>
      $inStock ? "rgba(201,162,39,0.35)" : "rgba(0,0,0,0.12)"};
  background: ${({ $inStock }) => ($inStock ? "#faf4e5" : "#f3f3f3")};
  color: ${({ $inStock }) => ($inStock ? c.black : "#666")};
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #ecdca4;
  margin: 16px 0 14px;

  @media (max-width: 768px) {
    margin: 12px 0 10px;
  }
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  flex-wrap: wrap;
  border-bottom: 1px solid #e8e0d2;
  padding-bottom: 4px;
`;

export const TabButton = styled.button`
  position: relative;
  border: none;
  background: transparent;
  padding: 8px 2px 10px;
  margin-right: 20px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? "#db7aa7" : c.black)};
  font-size: 15px;
  font-weight: 700;
  transition: 0.2s ease;
  white-space: nowrap;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -5px;
    width: 100%;
    height: 3px;
    border-radius: 999px;
    background: ${({ $active }) => ($active ? c.gold : "transparent")};
  }

  &:hover {
    color: #db7aa7;
  }

  @media (max-width: 768px) {
    font-size: 13.5px;
    margin-right: 14px;
    padding: 7px 2px 9px;
  }
`;

export const TabPanel = styled.div`
  margin-top: 14px;
  min-height: 110px;
  background: ${c.white};
  border: 1px solid #efe6d4;
  border-radius: 14px;
  padding: 14px;

  @media (max-width: 768px) {
    margin-top: 10px;
    min-height: 84px;
    padding: 12px;
    border-radius: 12px;
  }
`;

export const SectionText = styled.div`
  color: ${c.blackSoft};
  font-size: 14px;
  line-height: 1.75;
  white-space: pre-wrap;

  @media (max-width: 768px) {
    font-size: 13.5px;
    line-height: 1.65;
  }
`;

export const AddToCartButton = styled.button`
  margin-top: 16px;
  align-self: flex-start;
  min-width: 180px;
  padding: 13px 22px;
  border: 1px solid rgba(201, 162, 39, 0.34);
  border-radius: 999px;
  background: ${c.black};
  color: ${c.white};
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.25s ease;

  &:hover:not(:disabled) {
    background: ${c.gold};
    color: ${c.black};
    transform: translateY(-1px);
    box-shadow: 0 10px 26px rgba(201, 162, 39, 0.18);
  }

  &:disabled {
    opacity: 0.58;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
    margin-top: 14px;
    padding: 12px 18px;
    font-size: 12.5px;
  }
`;

export const NutritionTable = styled.div`
  width: 100%;
  border: 1px solid #efe6d4;
  border-radius: 14px;
  overflow: hidden;
  background: #fffdf8;
`;

export const NutritionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border-bottom: 1px solid #f3ecdf;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    padding: 11px 12px;
    gap: 10px;
  }
`;

export const NutritionLabel = styled.div`
  color: ${c.black};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 13.5px;
  }
`;

export const NutritionValue = styled.div`
  color: ${c.blackSoft};
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  text-align: right;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 13.5px;
  }
`;

export const NutritionNote = styled.p`
  margin: 12px 2px 0;
  color: ${c.blackSoft};
  font-size: 12.5px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const ProductGramajLine = styled.div`
  margin-top: 10px;
  color: ${c.black};
  font-size: 15px;
  line-height: 1.5;
  font-weight: 700;

  @media (max-width: 768px) {
    margin-top: 8px;
    font-size: 14px;
  }
`;
